import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { LOADING_END, LOADING_START } from "../../../lib/redux/slices/appSlice";

export const getUsers = createAsyncThunk(
  "GET_USERS",
  async (d, { dispatch }) => {
    dispatch(LOADING_START());
    const { data, status } = await axios.get("users/" + d);
    dispatch(LOADING_END());
    return { data, status };
  }
);
